
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.968 7.935v2.128c.829.185 1.566.488 2.337.697V8.629c-.825-.181-1.568-.484-2.337-.694zm7.09-3.843c-1.089.497-2.429.997-3.715.997C11.645 5.089 10.238 4 8.098 4c-.794 0-1.502.138-2.16.375.09-.228.131-.475.115-.737-.057-.888-.797-1.6-1.702-1.638-1.016-.04-1.851.76-1.851 1.75 0 .594.302 1.119.762 1.435V17.25c0 .416.34.75.762.75h.508a.754.754 0 00.762-.75V14.3c.899-.378 2.02-.69 3.633-.69 1.702 0 3.105 1.087 5.245 1.087 1.53 0 2.753-.51 3.89-1.278a.992.992 0 00.438-.825V4.998c.003-.728-.768-1.212-1.442-.906zm-9.427 8.08c-.819.085-1.587.257-2.337.52v-2.204c.832-.29 1.508-.468 2.337-.543v2.227zM16.98 7.97c-.75.306-1.47.609-2.337.746v2.222c.788-.106 1.632-.369 2.337-.812v2.203c-.797.503-1.54.771-2.337.846v-2.237c-.857.116-1.52.047-2.337-.175v2.106c-.759-.231-1.502-.522-2.337-.665v-2.14c-.625-.138-1.295-.213-2.337-.12V7.758c-.711.097-1.416.319-2.337.653V6.207c1.054-.38 1.591-.618 2.337-.687v2.237c.857-.115 1.537-.04 2.337.178V5.83c.753.231 1.499.522 2.337.666v2.137a6.144 6.144 0 002.337.084V6.47c.857-.15 1.66-.425 2.337-.703V7.97z","fill":"#525F7F"}})])
          )
        }
      }
    